"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFetch;

var _react = require("react");

function useFetch(url, requestOptions) {
  const [value, onChange] = (0, _react.useState)(["loading"]);
  (0, _react.useEffect)(() => {
    onChange(["loading"]);
    fetch(url, requestOptions).then(res => res.json()).then(data => {
      onChange(["success", data]);
    }).catch(err => {
      onChange(["error", String(err)]);
    });
  }, [url, requestOptions]);
  return value;
}
//# sourceMappingURL=useFetch.js.map